module.exports = __webpack_public_path__ + "img/ego-vs-self.69a7da26.jpg";